import { render, staticRenderFns } from "./Page_ResetPassword.vue?vue&type=template&id=9144dfea&scoped=true&"
import script from "./Page_ResetPassword.vue?vue&type=script&lang=js&"
export * from "./Page_ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9144dfea",
  null
  
)

export default component.exports